import { getUserId } from "../secure/secureManager";
import {
  changeUserLanguage,
  getUserSetting,
} from "../../serviceBroker/userApiServiceBroker";
import { SystemConfiguration } from "../../configuration";
import i18n from "../../components/languageSwitcher/react-i18/i18n";
import {
  secureLocalStorageGet,
  secureLocalStorageSet,
} from "../localStorage/localStorageManager";
import {isArabicCurrentLanguage} from "../localization/localizationManager";

// https://alyusrmobileapi.alyusrsoft.com/User/ChangeLanguage?userId=30&langugeType=1
export const handleLanguageChange = async (
  isFetchFromUserSetting?: boolean | null
) => {
  const currentUserId = getUserId();
  if (isFetchFromUserSetting) {
    const userSetting = await getUserSetting(currentUserId, true);
    const language =
      userSetting?.Lang == 1
        ? SystemConfiguration.culture_Configurations.arabicCulture
        : SystemConfiguration.culture_Configurations.englishCulture;
    i18n.changeLanguage(language).then(() => {});
    secureLocalStorageSet(
      SystemConfiguration.culture_Configurations.currentCulture || "",
      language
    );
  } else {
    const currentLanguage =
      (secureLocalStorageGet(
        SystemConfiguration.culture_Configurations.currentCulture
      ) as string) ??
      SystemConfiguration.culture_Configurations.defaultUiLanguage;

    const newLanguage =
      currentLanguage === "ar-AE"
        ? SystemConfiguration.culture_Configurations.englishCulture
        : SystemConfiguration.culture_Configurations.arabicCulture;

    const changeServerLang = await changeUserLanguage(
      currentUserId,
      currentLanguage === "ar-AE" ? 2 : 1
    );

    if (changeServerLang?.Errors?.length || !changeServerLang?.Result) {
      return;
    } else {
      i18n.changeLanguage(newLanguage).then(() => {});

      secureLocalStorageSet(
        SystemConfiguration.culture_Configurations.currentCulture || "",
        newLanguage
      );

      window.location.reload();
    }
  }
};
